import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, IconButton } from '@mui/material';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';

/**
 * "Was this helpful?" feedback widget for educational pages.
 * Fires a GA4 event on click.
 * @param {string} contentId - Unique ID for the content (slug or page key)
 */
export default function FeedbackWidget({ contentId }) {
  const { t } = useTranslation();
  const [vote, setVote] = useState(null); // 'yes' | 'no' | null

  const handleVote = (value) => {
    setVote(value);
    // GA4 event
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'content_feedback', {
        content_id: contentId,
        helpful: value,
      });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 3,
        mt: 4,
        borderTop: '1px solid #E6E9EE',
      }}
    >
      {vote ? (
        <Typography sx={{ fontSize: '14px', color: '#5F6B7A', fontWeight: 500 }}>
          {t('feedback.thanks', 'Gracias por tu opinión')}
        </Typography>
      ) : (
        <>
          <Typography sx={{ fontSize: '14px', color: '#5F6B7A', fontWeight: 500 }}>
            {t('feedback.question', '¿Te fue útil esta página?')}
          </Typography>
          <IconButton
            onClick={() => handleVote('yes')}
            sx={{
              color: '#2E7D32',
              bgcolor: '#E8F5E9',
              minWidth: 44,
              minHeight: 44,
              '&:hover': { bgcolor: '#C8E6C9' },
            }}
            aria-label="Sí, fue útil"
          >
            {vote === 'yes' ? <ThumbUpAltIcon /> : <ThumbUpAltOutlinedIcon />}
          </IconButton>
          <IconButton
            onClick={() => handleVote('no')}
            sx={{
              color: '#C62828',
              bgcolor: '#FFEBEE',
              minWidth: 44,
              minHeight: 44,
              '&:hover': { bgcolor: '#FFCDD2' },
            }}
            aria-label="No fue útil"
          >
            {vote === 'no' ? <ThumbDownAltIcon /> : <ThumbDownAltOutlinedIcon />}
          </IconButton>
        </>
      )}
    </Box>
  );
}
